<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Info</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            data-toggle="tooltip"
                            data-widget="collapse"
                            title="Collapse"
                            type="button"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div>
                    <div
                        v-if="category.id"
                        class="box-body"
                    >
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <strong>Name:</strong>
                                <p>{{ category.name }}</p>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <strong>Active:</strong>
                                <p>
                                    <ValueYesNo :value="category.active"></ValueYesNo>
                                </p>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <strong>Created At:</strong>
                                <p>{{ category.created_at }}</p>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <strong>Updated At:</strong>
                                <p>{{ category.updated_at }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <strong>Group:</strong>
                                <p>
                                    <a
                                        :href="getRouteGroup(category.group.id)"
                                        :title="category.group.name"
                                    >
                                        {{ category.group.name }}
                                    </a>
                                </p>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <strong>Bodies:</strong>
                                <p>
                                    <BadgeTotal
                                        :value="category.bodies_count"
                                        color="gray"
                                    ></BadgeTotal>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../../subcomponents/ValueYesNo';
import BadgeTotal from '../../subcomponents/BadgeTotal';

export default {
    components: {
        ValueYesNo,
        BadgeTotal,
    },
    data: function () {
        return {
            category: {},
            pageID: this.$route.params.id,
            route: {
                group: '/category-groups/:id:',
            },
        };
    },
    mounted() {
        this.getData(this.pageID);
    },
    methods: {
        getData(id) {
            axios
                .get('/predefined-bodies/categories/' + id + '/first?category=' + id)
                .then((response) => {
                    this.category = response.data.category;
                })
                .catch(() => {});
        },
        getRouteGroup: function (id) {
            return this.route.group.replace(':id:', id);
        },
    },
};
</script>
